import { Col, Divider, Row, Space } from "antd";
import { Input, Select } from "components/form";

import styles from "./AddressInformation.module.css";
import { useTranslation } from "react-i18next";

const Addressinformation = ({
  lower = null,
  provinceOptionsTh = [],
  provinceOptionsEn = [],
  districtOptionsTh = [],
  districtOptionsEn = [],
  subDistrictOptionsTh = [],
  subDistrictOptionsEn = [],
  onProviceChange = () => { },
  onDistrictChange = () => { },
  onSubDistrictChange = () => { },
}) => {
  const { t } = useTranslation();

  return (
    <Space direction="vertical" size={6}>
      <b className={styles.infoTopic}>
        {t("company_profile.label.address_information")}
      </b>
      <Divider />
      <Row gutter={[0, 16]}>
        <Col span={24}>
          <Input
            name="address"
            label={t("company_profile.label.address_th")}
            placeholder={t('address-detail-th')}
            size="large"
            required
          />
        </Col>
        <Col span={6} style={{ paddingRight: "12px" }}>
          <Select
            name="provinceId"
            label={t("address.province")}
            placeholder={t('please-select-1')}
            size="large"
            options={provinceOptionsTh}
            onChange={onProviceChange}
            required
          />
        </Col>
        <Col span={6} style={{ padding: "0px 12px" }}>
          <Select
            name="districtId"
            label={t("address.district")}
            placeholder={t('please-select-1')}
            size="large"
            options={districtOptionsTh}
            onChange={onDistrictChange}
            required
          />
        </Col>
        <Col span={6} style={{ padding: "0px 12px" }}>
          <Select
            name="subdistrictId"
            label={t("address.subdistrict")}
            placeholder={t('please-select-1')}
            size="large"
            options={subDistrictOptionsTh}
            onChange={onSubDistrictChange}
            required
          />
        </Col>
        <Col span={6} style={{ paddingLeft: "12px" }}>
          <Input
            name="zipCode"
            label={t("address.postal_code")}
            placeholder={t("address.postal_code")}
            size="large"
            maxLength={5}
            required
          />
        </Col>
        <Col span={24}>
          <Input
            name="addressEn"
            label={
              t("company_profile.label.address_en")
            }
            placeholder={t('address-detail-en')}
            size="large"
            required
          />
        </Col>
        <Col span={6} style={{ paddingRight: "12px" }}>
          <Select
            name="provinceId"
            label={t("address.province")}
            placeholder={t('please-select-1')}
            size="large"
            options={provinceOptionsEn}
            onChange={onProviceChange}
            required
          />
        </Col>
        <Col span={6} style={{ padding: "0px 12px" }}>
          <Select
            name="districtId"
            label={t("address.district")}
            placeholder={t('please-select-1')}
            size="large"
            options={districtOptionsEn}
            onChange={onDistrictChange}
            required
          />
        </Col>
        <Col span={6} style={{ padding: "0px 12px" }}>
          <Select
            name="subdistrictId"
            label={t("address.subdistrict")}
            placeholder={t('please-select-1')}
            size="large"
            options={subDistrictOptionsEn}
            onChange={onSubDistrictChange}
            required
          />
        </Col>
        <Col span={6} style={{ paddingLeft: "12px" }}>
          <Input
            name="zipCode"
            label={t("address.postal_code")}
            placeholder={t("address.postal_code")}
            size="large"
            maxLength={5}
            required
          />
        </Col>
      </Row>
      {lower}
    </Space>
  );
};

export default Addressinformation;
